import {useEffect} from 'react';

let locks = 0;

export const masterDataRefreshLocked = (): boolean => locks > 0;

export function lockMasterDataRefresh(): () => void {
    locks += 1;
    return () => {
        locks = Math.max(0, locks - 1);
    };
}

/** Hold the master-data refresh while a customer, product, or supplier editor is open. */
export function useMasterDataEditLock(open: boolean) {
    useEffect(() => {
        if (!open) return undefined;
        return lockMasterDataRefresh();
    }, [open]);
}
